<ng-container *ngIf="data">
	<dz-progress-spinner *ngIf="data.isLoading"></dz-progress-spinner>
	<section *ngIf="!data.isLoading && data.error">
		<em class="not-applicable margin-standard" [dcrHTMLKey]="data.error.errorCodes[0]">{{ data.error.debugMessage }}</em>
	</section>
</ng-container>
